import * as Sentry from '@sentry/vue';

export default ({ app, router }) => {
    Sentry.init({
        app,
        // dsn: 'https://3f3e725f7d69cf5a7e97101ee7fe1170@sentry.artes-cloud.ru/2',
        dsn: 'https://3f3e725f7d69cf5a7e97101ee7fe1170@sentry.etabl.ru/2',
        environment: process.env.DEV ? 'localhost' : `${process.env.APP_SERVICE_HOSTNAME === 'e-tabl.ru' ? 'develop' : 'production'}`,
        integrations: [
            Sentry.browserTracingIntegration(),
            Sentry.replayIntegration(),
            Sentry.browserProfilingIntegration(),

        ],
        tracesSampleRate: 0.8,
        profilesSampleRate: 0.8,
        tracePropagationTargets: [
            /^https:\/\/api\.etabl\.ru/,
            /^https:\/\/api\.e-tabl\.ru/,
            'localhost',
        ],

        allowUrls: ['localhost', 'etabl.ru', 'e-tabl.ru'],
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0,
    });
};
